import useToggle from 'src/common/hooks/helpers/useToggle'
import { AnyToken } from 'src/common/types/models/Tokens'
import Icon from 'src/common/ui-kit/Icon/Icon'
import TokenIcon from 'src/common/ui-kit/TokenIcon/TokenIcon'
import clsx from 'clsx'
import './styles.css'
import TokenSelectorModal from './components/modals/TokenSelectorModal'
import { useTranslation } from 'react-i18next'

export interface TokenSelectorProps {
  value?: AnyToken | null
  excludeToken?: AnyToken
  excludeNFT?: boolean
  onChange: (value: AnyToken) => void
  readonly?: boolean
  className?: string
  nftGroup?: boolean
  onlyOwned?: boolean
}

const TokenSelector = ({
  value,
  excludeToken,
  excludeNFT,
  onChange,
  readonly,
  className,
  nftGroup = false,
  onlyOwned,
}: TokenSelectorProps) => {
  const { t } = useTranslation('tokenSelector')

  const { isOn, off, on } = useToggle()

  return (
    <>
      <TokenSelectorModal
        excludeToken={excludeToken}
        excludeNFT={excludeNFT}
        open={isOn}
        onClose={off}
        onTokenSelect={onChange}
        nftGroup={nftGroup}
        onlyOwned={onlyOwned}
      />
      <div
        className={clsx(
          'ui-token-select-button',
          !readonly && 'cursor-pointer',
          className
        )}
        onClick={readonly ? undefined : on}
      >
        {value ? (
          <>
            <TokenIcon token={value} />
            {value.symbol}
          </>
        ) : (
          <span>{t('buttonCaption')}</span>
        )}
        {!readonly && <Icon name='arrow-down' />}
      </div>
    </>
  )
}

export default TokenSelector
